var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.title,
        width: "300px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        { attrs: { "label-width": "0" } },
        [
          _c(
            "el-form-item",
            [
              _c("el-input", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.operatorId === "btSiteRemark",
                    expression: "operatorId==='btSiteRemark'"
                  }
                ],
                attrs: { type: "textarea", rows: 5 },
                model: {
                  value: _vm.aeJob.siteRemark,
                  callback: function($$v) {
                    _vm.$set(_vm.aeJob, "siteRemark", $$v)
                  },
                  expression: "aeJob.siteRemark"
                }
              }),
              _c("el-input", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.operatorId === "btOperatorRemarks",
                    expression: "operatorId==='btOperatorRemarks'"
                  }
                ],
                attrs: { type: "textarea", rows: 5 },
                model: {
                  value: _vm.aeJob.remarks,
                  callback: function($$v) {
                    _vm.$set(_vm.aeJob, "remarks", $$v)
                  },
                  expression: "aeJob.remarks"
                }
              }),
              _c("el-input", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.operatorId === "btOtherWarehouseNotes",
                    expression: "operatorId==='btOtherWarehouseNotes'"
                  }
                ],
                attrs: { type: "textarea", rows: 5 },
                model: {
                  value: _vm.aeJob.otherWarehouseNotes,
                  callback: function($$v) {
                    _vm.$set(_vm.aeJob, "otherWarehouseNotes", $$v)
                  },
                  expression: "aeJob.otherWarehouseNotes"
                }
              }),
              _c("el-input", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.operatorId === "btOtherCharges",
                    expression: "operatorId==='btOtherCharges'"
                  }
                ],
                attrs: { type: "textarea", rows: 5 },
                model: {
                  value: _vm.aeJob.otherCharges,
                  callback: function($$v) {
                    _vm.$set(_vm.aeJob, "otherCharges", $$v)
                  },
                  expression: "aeJob.otherCharges"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.clickHandler } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }